import { render, staticRenderFns } from "./UiMugenScroll.vue?vue&type=template&id=80c1c758"
import script from "./UiMugenScroll.vue?vue&type=script&lang=js"
export * from "./UiMugenScroll.vue?vue&type=script&lang=js"
import style0 from "./UiMugenScroll.vue?vue&type=style&index=0&id=80c1c758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports